import { Component, OnInit } from '@angular/core';
import { NgForm, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BackendService } from '../../shared/backend.service';
//import { NotificationService } from '../../notification/notification.service';
import { AuthService } from '../../shared/auth.service';
import CONFIG from '../../config';
import { Response } from '@angular/http';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AlertmessageService } from 'src/app/shared/alertmessage.service';
import { callNgModuleLifecycle } from '@angular/core/src/view/ng_module';
import { NotificationService } from 'src/app/notification.service';
//import { NotificationService } from 'src/app/notification.service';


@Component({
  selector: 'app-post-no-accounts',
  templateUrl: './post-no-accounts.component.html',
  styleUrls: ['./post-no-accounts.component.scss'],
  providers:[DatePipe]
})
export class PostNoAccountsComponent implements OnInit {
  postnoAccounts: FormGroup;
  //DateFilter: FormGroup;
  enddate: any;
  //item: any;
  bankId: any;
  branchcodes: any;
  branchfiltercodes: any;
  bankbranchids: any;
  bankcodevalue:any;
 // selected = '2018';
  picker1: any;
  //branchcodesarray: any=[];
  branchessss: Array<string>;
  years: number[] = [];
  selected: number;

  constructor(
    public _formBuilder: FormBuilder,
    public backendService: BackendService,
    public authService: AuthService,
    public _notificationService: NotificationService,
    public router:Router,
    public _datepipe:DatePipe,
    public  alert:AlertmessageService
  ) {
    this.setForm();
  }

  ngOnInit() {
    
    this.enddate = new FormControl(new Date());
    //console.log(this.enddate);
    
    this.getbankIdDropdown();
    //this.initializeYears();
    const currentYear = new Date().getFullYear();
    for (let year = 2017; year <= currentYear; year++) {
      this.years.push(year);
    }
  }

  // initializeYears() {
  //   const startYear = 2017;
  //   const currentYear = new Date().getFullYear();
  //   this.years = Array.from({ length: currentYear - startYear + 1 }, (v, k) => startYear + k);
  // }

  getbankIdDropdown() {
    this.backendService.getData(`${CONFIG.getbankIdDropdownApiUrlBase}`)
      .subscribe(response => {
        this.bankId = response['bankid'];
        this.branchcodes = response['branchcodelist'];
        this.bankbranchids = response['bankbranchids'];
       // console.log(this.bankId, this.branchcodes, this.bankbranchids);
      });
  }
 filterBranchCode() {
   
    let myArray = [];
    this.bankcodevalue = this.postnoAccounts.controls['BankCode'].value;
    this.branchfiltercodes = this.bankbranchids.filter(x => x.bankCode == this.bankcodevalue);
    for (var i = 0; i < this.branchfiltercodes.length; i++) {
      this.branchessss = this.branchfiltercodes[i]['branchCode'];
      myArray.push(this.branchessss);
      //console.log(myArray);
   }
   this.branchcodes = myArray;
   //console.log(this.branchcodes);
  }

  onSubmit(model) 
  {
    //console.log(model, this.selected, this.enddate);
    if(this.authService.LoginType=="Admin")
    {
        if(this.bankcodevalue==""||model.BankCode==""||model.BranchCode=="")
        {

            this.alert.openConfirmationDialog("Please Select Bank ID and Branch Code.");
        }
        else if(model.Year==""||model.Comments==""||model.FirstName==""||model.LastName==""||model.EmailAddress==""||model.Phone==""||model.Position=="")
        {
          this.alert.openConfirmationDialog("Please Fills Fields.");
        }
        else
        {
        model.date=this._datepipe.transform(this.enddate.value,"MM/dd/yyyy");
        this.backendService.postData(model, `${CONFIG.postnoaccountsApiUrlBase}`)
          .subscribe(response => {
           // console.log(response);
            if (response) {
              this.setForm();
              this._notificationService.showNotification({type:'success',message :response['msg']});
              this.router.navigate(['/dashboard']);
            } else {
              this._notificationService.showNotification({type:'error',message:response['msg']});

            }
          });
        }
    }
  else
  {
    if(model.Year==""||model.Comments==""||model.FirstName==""||model.LastName==""||model.EmailAddress==""||model.Phone==""||model.Position=="")
    {
      this.alert.openConfirmationDialog("Please Fills Fields.");
    }
    else
    {
      model.BankCode=this.authService.TaskNumber;
    model.date=this._datepipe.transform(this.enddate.value,"MM/dd/yyyy");
    this.backendService.postData(model, `${CONFIG.postnoaccountsApiUrlBase}`)
      .subscribe(response => {
       // console.log(response);
        if (response) {
          this.setForm();
          this._notificationService.showNotification({type:'success',message :response['msg']});
          this.router.navigate(['/dashboard']);
        } else {
          this._notificationService.showNotification({type:'error',message:response['msg']});

        }
      });
  
  }
}
}
  setForm() {
    this.postnoAccounts = this._formBuilder.group({
      'BankCode': [''],
      'BranchCode': [''],
      'enddate': [''],
      'date': [''],
      'Year': [''],
      'FirstName': [''],
      'MiddleName': [''],
      'LastName': [''],
      'Position': [''],
      'EmailAddress': [''],
      'Phone': [''],
      'Comments': ['']
    });
  }
}
